// 枚举列表  代码可读性考量
// 设备配置状态
export const ENUM_CONFIG_STATUS = {
  WAIT: 0,
  CONFIGURING: 1,
  CONFIGURED: 2,
  FAIL: 3
}

// 传感器状态
export const ENUM_DEVICE_STATUS = {
  ONLINE: 1,
  OFFLINE: 0
}

// 设备绑定 未绑定 停用 未确认 状态
export const ENUM_DEVICE_WAY = {
  BIND: 'bind',
  UNBIND: 'unbind',
  STOP: 'stop',
  UNCONFIRM: 'unknown'
}

// zigbee 参数状态
export const ENUM_ZIGBEE_PARAMS_STATUS = {
  NO_REPORT: 1,
  NORMAL: undefined
}

// 电源状态
export const ENUM_POWER_STATUS = {
  NO_POWER: 1,
  NORMAL: undefined
}

// TCP连接状态
export const ENUM_TCP_STATUS = {
  ABNORMAL: undefined,
  NORMAL: 1
}

// LTE连接状态
export const ENUM_LTE_STATUS = {
  ABNORMAL: undefined,
  NORMAL: 1
}

// 飞行模式
export const ENUM_AIRPLANE_MODE = {
  AIRPLANE_MODE: 1,
  NO_AIRPLANE_MODE: undefined
}

// 设备类型
export const ENUM_DEVICE_TYPE = {
  SENSOR: 0,
  GATEWAY: 1,
  DISPLAY: 2,
  RELAY: 3,
  BASE: 4
}

export const ENUM_GATEWAY_LPWAN_MODE = {
  MODEM_GF: 1,
  MODEM_LR: 2,
  MODEM_FL: 3
}

/**
 * 二代zigbee工作模式
 * @type {{ASYNC: number, FIXED: number, SYNC: number}}
 */
export const ENUM_TWO_GEN_ZIGBEE_WORK_MODE = {
  // 异步模式
  ASYNC: 1,
  // 同步模式
  SYNC: 2,
  // 固定模式
  FIXED: 3
}

/**
 * 4G传感器工作模式
 * @type {{RANGE_CHANGE_AMOUNT: number, COLLECT: number, FIXED: number}}
 */
export const ENUM_FOUR_G_SENSOR_WORK_MODE = {
  // 区间变化量模式
  RANGE_CHANGE_AMOUNT: 1,
  // 同步模式
  SYNC: 2,
  // 固定模式
  FIXED: 3
}
